import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { DomSanitizer } from "@angular/platform-browser";
import { HttpClient } from "@angular/common/http";


const modules = [
  MatFormFieldModule,
  MatSelectModule,
  MatInputModule,
  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
  MatCheckboxModule,
  MatBadgeModule,
  MatMenuModule,
  MatTableModule
];

@NgModule({
  declarations: [],

  imports: [CommonModule, modules],
  exports: [modules],
  providers: [MatIconRegistry,HttpClient]
})
export class MaterialModule {
  path='../../../assets/img/icons';

   constructor(private domSanitizer:DomSanitizer,private matIconRegistry:MatIconRegistry){
    this.matIconRegistry
    .addSvgIcon('filter',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/filter.svg`))
    .addSvgIcon('clear',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/clear.svg`))
    .addSvgIcon('dayAction',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/day-action.svg`))
    .addSvgIcon('action',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/action.svg`))
    .addSvgIcon('requestList',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/request-list.svg`))
    .addSvgIcon('download',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/download.svg`))
    .addSvgIcon('forward',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/fast-forward.svg`))
    .addSvgIcon('backward',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/rewind.svg`))
    .addSvgIcon('download-template',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/download-template.svg`))
    .addSvgIcon('edit',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/edit.svg`))
    .addSvgIcon('delete-1',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/delete-1.svg`))
    .addSvgIcon('role-update',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/role-update.svg`))
    .addSvgIcon('update-user',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/update_user.svg`))
    .addSvgIcon('map1',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/map1.svg`))
    .addSvgIcon('map2',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/map2.svg`))
    .addSvgIcon('refresh',this.domSanitizer.bypassSecurityTrustResourceUrl(`${this.path}/refresh.svg`))
  }

 }
